/* eslint-disable */
export default {
  notActivated: 'Inattivo',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
